import React from 'react';

function HowItWorks() {
  return (
    <section className="section how-it-works-section">
      <div className="container">
        <div className="how-grid">
          <div className="steps-side">
            <h2 className="section-title" style={{ fontSize: '38px' }}>Get Started in 3 Simple Steps</h2>
            <p style={{ color: '#64748b', fontSize: '14px', marginTop: '8px', marginBottom: '32px' }}>Follow these easy steps to transform your school management</p>
            
            <div className="steps-list">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Setup your school in minutes</h3>
                  <p>Quick onboarding with customizable settings to match your school's structure and requirements.</p>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Add classes, parents and students</h3>
                  <p>Import or manually add all your data with bulk upload features and organized management tools.</p>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Start managing academics & admin</h3>
                  <p>Begin using all features immediately with intuitive dashboards and comprehensive support.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="workflow-side">
            <div className="workflow-image">
              <div style={{ width: '85%', height: '85%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '24px' }}>
                <div className="workflow-icon-row">
                  <div className="workflow-icon-box">🏫</div>
                  <div className="workflow-arrow"></div>
                  <div className="workflow-icon-box">👨‍🏫</div>
                  <div className="workflow-arrow"></div>
                  <div className="workflow-icon-box">👨‍🎓</div>
                </div>
                <div style={{ textAlign: 'center', color: '#64748B', fontSize: '14px', fontWeight: '600', maxWidth: '300px', lineHeight: '22px' }}>Seamless integration between school admin, teachers, and students</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
